export default __webpack_public_path__ + "static/media/14.bdf9119f.png";